import { createReducer } from '@reduxjs/toolkit';
import get from 'lodash/get';

import {
  ActionSuccessType,
  GET_AVAILABLE_CHARITIES_FOR_RECOMMENDATION,
  GET_EXPERT_BADGES,
  GET_SITE,
  GET_SITE_ASSOCIATIONS,
  GET_SITE_VISIBLE_KEYWORDS,
} from 'constants/redux-actions';

const initState = {};

const siteReducer = createReducer(initState, {
  [ActionSuccessType(GET_SITE)]: (prevState, action) => ({ ...prevState, ...action.payload.data }),
  [ActionSuccessType(GET_SITE_VISIBLE_KEYWORDS)]: (prevState, action) => {
    const keywords = get(action, 'payload.data', []);

    return {
      ...prevState,
      searchTags: keywords,
      areasOfExpertise: keywords.filter(({ starred }) => starred),
      searchableKeywords: keywords.filter(({ starred }) => !starred),
    };
  },
  [ActionSuccessType(GET_AVAILABLE_CHARITIES_FOR_RECOMMENDATION)]: (prevState, action) => {
    const availableCharitiesForRecommendation = get(action, 'payload.data', []);

    return {
      ...prevState,
      availableCharitiesForRecommendation,
    };
  },
  [ActionSuccessType(GET_EXPERT_BADGES)]: (prevState, action) => {
    const expertBadges = get(action, 'payload.data', []);

    return {
      ...prevState,
      expertBadges,
    };
  },
  [ActionSuccessType(GET_SITE_ASSOCIATIONS)]: (prevState, action) => ({ ...prevState, ...action.payload.data }),
});

export default siteReducer;
